import { SVG } from '../svg';
import { IconProps } from '../types';

export function FilterIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <path d="M3 6h18" />
      <path d="M7 12h10" />
      <path d="M10 18h4" />
    </SVG>
  );
}
